import * as React from "react";

export function GetPublicAdress() {
    if (process.env.NODE_ENV=="development"){
        return 'http://alexander.abc/Fencing'
    }
    else
    {
        if (process.env.NODE_ENV=="test"){
            return 'http://fencing.lv/Fencing.Api/v1.0'
        }

        if (process.env.NODE_ENV=="production"){
            return 'http://fencing.lv/Fencing.Api/v1.0'
        }

      return "";
    }
}
    